import React from 'react'
import * as utils from '../../utils'
import { Link } from 'react-router-dom'

const MapPriceTag = props => {
  const { cw, hovered, linkTo } = props
  const priceTag = `$${utils.withCommas(props.price || 0)}`
  const perCharWidth = 9
  const priceTagLen = priceTag.length
  const priceTagWidth = priceTagLen === 1 ? cw : perCharWidth * priceTagLen
  const orgX = priceTagWidth * 0.5
  const orgY = cw

  return (
    <Link
      to={linkTo}
      style={{
        textDecoration: 'none',
        color: 'black',
        width: priceTagWidth,
        height: cw,
        cursor: 'pointer',
        top: 5,
        left: -orgX,
        position: 'absolute',
        transformOrigin: `${orgX} ${orgY}`,
        margin: 0,
        padding: 0,
        borderRadius: '4px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '12px',
        fontFamily: 'Rubik',
        fontWeight: 500,
        backgroundColor: hovered ? '#ffd200' : '#ffffff',
      }}>
      {' '}
      {priceTag}{' '}
    </Link>
  )
}

MapPriceTag.defaultProps = {
  cw: 24,
}
export default MapPriceTag



// WEBPACK FOOTER //
// ./src/components/map/MapPriceTag.js